import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-31e99cc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navBox"
};
const _hoisted_2 = {
  class: "navBoxTop"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_4 = {
  class: "rightBtnBox"
};
const _hoisted_5 = {
  class: "phoneBtn"
};
const _hoisted_6 = {
  style: {
    "display": "none"
  }
};
const _hoisted_7 = {
  key: 0,
  class: "phoneBtnLine"
};
const _hoisted_8 = {
  class: "navBtn PCBtn"
};
const _hoisted_9 = {
  class: "navBtn PCBtn"
};
const _hoisted_10 = {
  key: 1,
  class: "phoneBtnLine"
};
const _hoisted_11 = {
  class: "navBtn PCBtn"
};
const _hoisted_12 = {
  class: "navBtn PCBtn"
};
const _hoisted_13 = {
  style: {
    "display": "none"
  }
};
const _hoisted_14 = {
  class: "navbar-collapse collapse show",
  id: "ftco-nav",
  style: {}
};
const _hoisted_15 = {
  key: 0,
  class: "navbar-nav nav ml-auto"
};
const _hoisted_16 = {
  class: "nav-item cta width-110px",
  style: {
    "padding": "20px",
    "text-align": "center"
  }
};
const _hoisted_17 = {
  class: "nav-item cta width-110px",
  style: {
    "padding": "20px",
    "text-align": "center"
  }
};
const _hoisted_18 = {
  key: 1,
  class: "navbar-nav nav ml-auto"
};
const _hoisted_19 = {
  class: "nav-item cta width-110px",
  style: {
    "padding": "20px",
    "text-align": "center"
  }
};
const _hoisted_20 = {
  class: "nav-item cta width-110px",
  style: {
    "padding": "20px",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popover = _resolveComponent("van-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    height: "40",
    width: "100",
    src: require('@/assets/img/logo.png')
  }, null, 8, ["src"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toServer()),
    class: "phoneBtn"
  }, [_createVNode(_component_van_icon, {
    color: "#000",
    size: "28",
    name: require('@/assets/img/server.png')
  }, null, 8, ["name"])]), _createVNode(_component_van_popover, {
    show: _ctx.showPopover,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => _ctx.showPopover = $event),
    actions: _ctx.actions,
    onSelect: _ctx.onSelect,
    placement: "bottom-end"
  }, {
    reference: _withCtx(() => [_createElementVNode("button", _hoisted_5, [_createVNode(_component_van_icon, {
      color: "#000",
      size: "28",
      name: require('@/assets/img/lang.png')
    }, null, 8, ["name"])])]),
    action: _withCtx(({
      action
    }) => [_createElementVNode("div", null, _toDisplayString(action.name), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(action.code), 1)]),
    _: 1
  }, 8, ["show", "actions", "onSelect"]), _createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.visible = !_ctx.visible),
    class: "phoneBtn"
  }, "MENU"), !_ctx.userToken ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push('/login'))
  }, _toDisplayString(_ctx.$t('navtab.login')), 1)]), _createElementVNode("span", _hoisted_9, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push('/register'))
  }, _toDisplayString(_ctx.$t('navtab.register')), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.$router.push('/memberCenter'))
  }, _toDisplayString(_ctx.$t('navtab.memberCenter')), 1)]), _createElementVNode("span", _hoisted_12, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = (...args) => _ctx.logOut && _ctx.logOut(...args))
  }, _toDisplayString(_ctx.$t('navtab.logout')), 1)])])), _createVNode(_component_van_icon, {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.toServer()),
    class: "PCBtn",
    color: "#000",
    size: "28",
    name: require('@/assets/img/server.png')
  }, null, 8, ["name"]), _createVNode(_component_van_popover, {
    show: _ctx.showPcPopover,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => _ctx.showPcPopover = $event),
    actions: _ctx.actions,
    onSelect: _ctx.onSelect,
    placement: "bottom-end"
  }, {
    reference: _withCtx(() => [_createVNode(_component_van_icon, {
      class: "PCBtn",
      color: "#000",
      size: "28",
      name: require('@/assets/img/lang.png')
    }, null, 8, ["name"])]),
    action: _withCtx(({
      action
    }) => [_createElementVNode("div", null, _toDisplayString(action.name), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(action.code), 1)]),
    _: 1
  }, 8, ["show", "actions", "onSelect"])])]), _withDirectives(_createElementVNode("div", _hoisted_14, [!_ctx.userToken ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [_createElementVNode("li", _hoisted_16, [_createElementVNode("a", {
    onClick: _cache[9] || (_cache[9] = $event => _ctx.$router.push('/login')),
    class: "nav-link"
  }, _toDisplayString(_ctx.$t('navtab.login')), 1)]), _createElementVNode("li", _hoisted_17, [_createElementVNode("a", {
    onClick: _cache[10] || (_cache[10] = $event => _ctx.$router.push('/register')),
    class: "nav-link"
  }, _toDisplayString(_ctx.$t('navtab.register')), 1)])])) : (_openBlock(), _createElementBlock("ul", _hoisted_18, [_createElementVNode("li", _hoisted_19, [_createElementVNode("a", {
    onClick: _cache[11] || (_cache[11] = $event => _ctx.$router.push('/memberCenter')),
    class: "nav-link"
  }, _toDisplayString(_ctx.$t('navtab.memberCenter')), 1)]), _createElementVNode("li", _hoisted_20, [_createElementVNode("a", {
    onClick: _cache[12] || (_cache[12] = (...args) => _ctx.logOut && _ctx.logOut(...args)),
    class: "nav-link"
  }, _toDisplayString(_ctx.$t('navtab.logout')), 1)])]))], 512), [[_vShow, _ctx.visible]])]);
}